module.exports = __webpack_public_path__ + "img/logo.9fce24ba.png";